import styled from "styled-components";
import { Button } from "reactstrap";

export const StepTexth4 = styled.h3`
  margin: 0;
  text-align: center;
  color: #0c2b6e;
  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px; /* Aumentar a largura */
  max-width: 900px;
  height: auto;
  min-height: 25vh;
  max-height: 85vh;
  overflow-y: auto;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.61);
  z-index: 1000;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (max-width: 768px) {
    width: 90%;
    max-width: 90%;
    padding: 25px;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 25px;
  }
`;

export const StepContainer = styled.div`
  margin: 10px 0;

  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    margin: 8px 0;
  }

  @media (max-width: 480px) {
    margin: 5px 0;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  border: none;

  background: #e9ecef;
  color: #333;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: #dee2e6;
  }
`;

export const SubText = styled.p`
  text-align: center;
  color: #4f565c;
  font-size: 17px;
  margin-top: 10px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 25px;

  button {
    min-width: 140px;
    height: 45px;
    font-weight: 600;
    border-radius: 8px;
  }
`;


export const ButtonNext = styled(Button)`
  width: 15%;
  padding: 10px 25px;
  border-radius: 4px;
  border: none;
  font-size: 18px;
  font-weight: 600;
  background-color: #0c2b6e;
  margin-top: 20px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 40%;
    font-size: 16px;
  }

  @media (max-width: 480px) {
    width: 60%;
    font-size: 14px;
  }
`;
